import { ChordProgression } from '../models';

export const getNBarRange = (chordProgressions: ChordProgression[]) => {
  const minNBar: number = Math.min(...chordProgressions.map((chordProgression, _) => chordProgression.nBar));
  const maxNBar: number = Math.max(...chordProgressions.map((chordProgression, _) => chordProgression.nBar));
  return { minNBar, maxNBar };
};
